import getLowestCabinRate from './getLowestCabinRate';

const getCabinCategoryMinRate = ({ cabins, cabinGroups }) => {
  let rate = 0;
  let isTotalAmount = false;
  if (cabins && cabins.length) {
    if (cabins[0].lowestTotalAmount > 0) {
      isTotalAmount = true;
      rate = cabins[0].lowestTotalAmount;
    } else {
      rate = cabins[0].lowestRate;
    }
  } else {
    rate = getLowestCabinRate(cabinGroups, true);
    if (rate > 0) {
      isTotalAmount = true;
    } else {
      rate = getLowestCabinRate(cabinGroups);
    }
  }
  return {
    isTotalAmount,
    rate,
  };
};

export default getCabinCategoryMinRate;
